import { render, staticRenderFns } from "./Msgblacklist.vue?vue&type=template&id=427c8ad2&scoped=true&"
import script from "./Msgblacklist.vue?vue&type=script&lang=js&"
export * from "./Msgblacklist.vue?vue&type=script&lang=js&"
import style0 from "./Msgblacklist.vue?vue&type=style&index=0&id=427c8ad2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427c8ad2",
  null
  
)

export default component.exports